"use client";

import { useEffect, useRef, useState, type ReactNode } from "react";
import { ArrowUpRight } from "lucide-react";
import { BiteButton } from "./bite-ui";
import {isBiteLoginOpen} from '@/lib/bite-signup-referral';

export function BiteCinemaFrame({ children, initialFullscreen = false, working, title, onFullscreenChange }: {
  children: ReactNode;
  initialFullscreen?: boolean;
  working: boolean;
  title: string;
  onFullscreenChange?: (expanded: boolean) => void;
}) {
  const [expanded, setExpanded] = useState(initialFullscreen);
  const [loginActive, setLoginActive] = useState(isBiteLoginOpen);
  const dialogRef = useRef<HTMLDialogElement>(null);
  const resumeRef = useRef<HTMLButtonElement>(null);
  const changeFullscreen = (value: boolean) => { setExpanded(value); onFullscreenChange?.(value); };
  useEffect(()=>{
    const showLogin=()=>{
      const dialog=dialogRef.current;
      if(dialog?.matches(':modal')){dialog.close();dialog.show();}
      setLoginActive(true);
    };
    const closeLogin=()=>setLoginActive(false);
    window.addEventListener('bite:login',showLogin);
    window.addEventListener('bite:login:close',closeLogin);
    return()=>{window.removeEventListener('bite:login',showLogin);window.removeEventListener('bite:login:close',closeLogin);};
  },[]);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (!expanded || loginActive) {
      if (dialog.matches(":modal")) {
        dialog.close();
        dialog.show();
        if(!loginActive)resumeRef.current?.focus({ preventScroll: true });
      }
      return;
    }
    const overflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    if (dialog.open) dialog.close();
    dialog.showModal();
    dialog.focus({ preventScroll: true });
    return () => {
      document.body.style.overflow = overflow;
      if (dialog.open) dialog.close();
      if (dialog.isConnected) dialog.show();
    };
  }, [expanded,loginActive]);

  return <dialog open tabIndex={-1} ref={dialogRef} className="bite-cinema bite-scope bite-light"
    data-fullscreen={expanded} data-login-active={loginActive} data-working={working} aria-label={title}
    aria-modal={expanded&&!loginActive || undefined}
    onCancel={(event) => { event.preventDefault(); changeFullscreen(false); }}>
    <div className="bite-cinema__toolbar">
      {working && <span className="bite-cinema__brand">Bite</span>}
      {expanded ? <BiteButton variant="ghost" data-track="bite.cinema.collapse" onClick={() => changeFullscreen(false)} aria-keyshortcuts="Escape">
        {working ? "애니메이션 건너뛰기" : "전체 화면 닫기"}<kbd>Esc</kbd>
      </BiteButton> : <BiteButton ref={resumeRef} variant="ghost" data-track="bite.cinema.expand" onClick={() => changeFullscreen(true)}>
        전체 화면으로 보기<ArrowUpRight aria-hidden="true" />
      </BiteButton>}
    </div>
    {children}
  </dialog>;
}
